export default __webpack_public_path__ + "static/media/spinner.04966eb1.svg";